const heightObserver = callback => {
  let observables = [];
  // Array of observed elements that looks like const :
  // [{
  //   el: domNode,
  //   size: {height: x}
  // }]

  const observe = el => {
    if (observables.some(observable => observable.el === el)) {
      return;
    }
    const newObservable = {
      el: el,
      size: {
        height: el.clientHeight,
      },
    };
    observables.push(newObservable);
  };

  const unobserve = el => {
    observables = observables.filter(obj => obj.el !== el);
  };

  const check = () => {
    const changedEntries = observables
      .filter(obj => {
        const currentHeight = obj.el.clientHeight;
        if (obj.size.height !== currentHeight) {
          obj.size.height = currentHeight;
          return true;
        }
      })
      .map(obj => obj.el);
    if (changedEntries.length > 0) {
      callback(changedEntries);
    }
    window.requestAnimationFrame(check);
  };

  check();

  const unload = () => {
    observables = [];
  };

  return { unload, observe, unobserve };
};

export default heightObserver;
